import { useQuery } from "react-query";
import { API_KEY_GET_MANAGEABLE_NOTIFICATIONS } from "../constants";
import { getManageableNotifications } from "../api";

export const useGetManageableNotifications = (params) => {
  return useQuery([API_KEY_GET_MANAGEABLE_NOTIFICATIONS, params], () =>
    getManageableNotifications(params)
  );
};
